import classNames from 'classnames';
import { Spinner } from './Spinner';
import { useEffect, useState } from 'react';

export const GoldButton = ({ children, className, error, onClick, showloader = false, shadow = false, ...props }) => {
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (error) {
            setIsLoading(false);
        }
    }, [error]);

    return (
        <button
            className={classNames(className, {
                'w-full mt-4': true,
                'flex items-center justify-center': true,
                'py-4 px-4 rounded-xl': true,
                'bg-[#FFD700] hover:bg-[#F2CD00] text-[#001C3D]': true,
                'font-semibold text-sm': true,
                'cursor-pointer': true,
                "border-none": !shadow,
                'shadow-xl border border-black/10': shadow,
            })}
            {...props}
            onClick={event => {
                setIsLoading(true);
                onClick(event);
            }}
        >
            {(!error && showloader && isLoading) ? <Spinner /> : children}
        </button>
    );
}